export const MAX_ACCOUNTS = 30;
export const PENDING_SESSION_SWITCH_KEY = 'cio-pending-session-switch';
export const EXPIRED_SESSION_SNACKBAR_KEY = 'cio-expired-session-snackbar';
export const SESSION_METADATA_REFETCH_INTERVAL = 5 * 60 * 1000; // 5 minutes
export const WORKSPACE_MISMATCH_SNACKBAR_KEY = 'cio-workspace-mismatch-snackbar';
